module.exports = __webpack_public_path__ + "img/close.3bbe74fb.svg";